import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=4c02b2bd&scoped=true"
import script from "./NewsContent.vue?vue&type=script&lang=js"
export * from "./NewsContent.vue?vue&type=script&lang=js"
import style0 from "./NewsContent.vue?vue&type=style&index=0&id=4c02b2bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c02b2bd",
  null
  
)

export default component.exports